import { useEffect } from 'react';

export function useCheckVersionAndRefreshApp() {
  useEffect(() => {
    setInterval(async () => {
      const response = await fetch('/api/checkVersion');
      const { version } = await response.json();
      const currentVersion = document
        ?.querySelector('meta[name="version"]')
        ?.getAttribute('content');

      if (currentVersion && version && version !== currentVersion) {
        window.location.reload();
      }
    }, 1_800_000); // 30 minutes
  }, []);
}
